module.exports = __webpack_public_path__ + "img/tw-btn_txt.d1e3e11f.png";